import ModelBase from "../../../../framework/core/mvvm/model_base";
import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
const {ccclass, property} = cc._decorator;

@ccclass
export class GameChatModel extends ModelBase {

    send_chat(chatMsgType: number, text: string){
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this.sendMsg(NetMsgDataBase.Chat, protoData)
    }
}
